// import axios from "axios";
import Properties from "../properties";
import apiClient from "../plugins/axios-instance";

const API_URL = "https://barang." + Properties.DOMAIN_URL + "/api/v1";

export default class BarangAPIService {
  constructor() {}
  static getAllDept = (limit, page) => {
    return apiClient.get(
      API_URL + "/departments/limit/" + limit + "?page=" + page,
    );
  };
  static getAllActiveDept = (limit, page) => {
    return apiClient.get(
      API_URL + "/departments/limit/" + limit + "?page=" + page,
      {
        params: { status: 'A'}
      }
    );
  };
  static createDept = (dept) =>
    apiClient.post(API_URL + "/departments", dept);
  static editDept = (id, dept) =>
    apiClient.put(API_URL + "/departments/" + id, dept);
  static delete = (kode, nik) =>
    apiClient.delete(API_URL + "/departments/" + kode, {
      params: {
        user_update: nik,
      },
    });
}
